// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { forgotPasswordEndPoint, loginHeaders, changePassword, accessToken,refreshTokenEndPoint, refreshTokenCall } from "../common/api-config";
import ServiceHelper from "./serviceHelper";

/**
 * Functions required for a connection service
 * @member save - Save a connection
 */
export interface ILoginService {
    login(requestBody: any): Promise<void>;
}

/**
 * @name - Connection Service
 * @description - Functions for dealing with project connections
 */
export default class LoginService implements ILoginService {

    /**
     * Login connection
     * @param connection - Connection to save
     */
    public login = async (body: any) => {
        let response;
        const headers = loginHeaders;
        // https://azfun-jbs-userlogin-dev-001.azurewebsites.net/api/userlogin *** jbs Login
        // https://user-login-api.azurewebsites.net/api/userlogin *** ai-dcap-login
        try {
           // response = await ServiceHelper.postWithAutoRetry(
               // "https://user-login-api.azurewebsites.net/api/userlogin", body, { headers });
                  response = await ServiceHelper.postWithAutoRetry(
                "https://azfun-chep-user-login-python-prod-001.azurewebsites.net/api/UserLogin", body, { headers });
            return response.data;
        } catch (err) {
            ServiceHelper.handleServiceError(err);
        }
    }

    /**
     * Login connection
     * @param connection - Connection to save
     */
    public changePassword = async (body: any) => {
        let response;
        let headers = accessToken()
        try {
            response = await ServiceHelper.postWithAutoRetry(
                changePassword(), body, { headers });
            console.log(response, "***response**");
            return response.data;
        } catch (err) {
            let response;
            if(err.response.status == 401){
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if(response.data.status == 200){
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.postWithAutoRetry(
                            changePassword(), body, { headers });
                        console.log(response, "***response**");
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            }else{
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    /**
     * Login connection
     * @param connection - Connection to save
     */
    public forgotPassword = async () => {
        let response;
        try {
            response = await ServiceHelper.postWithAutoRetry(
                forgotPasswordEndPoint());
            return response.data;
        } catch (err) {
            ServiceHelper.handleServiceError(err);
        }
    }

}
